import React from 'react'
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface IconButtonProps extends MuiIconButtonProps {
  /** Quieter chrome for immersive / photo surfaces */
  tone?: 'default' | 'quiet' | 'inverse' | 'night'
}

const Root = styled(MuiIconButton, {
  shouldForwardProp: (p) => p !== 'tone',
})<{ tone: NonNullable<IconButtonProps['tone']> }>(({ tone }) => ({
  borderRadius: 'var(--ds-radius-pill)',
  transition: `background var(--ds-duration-fast) var(--ds-ease)`,
  ...(tone === 'quiet' && {
    color: 'var(--ds-ink-muted)',
    '&:hover': { backgroundColor: 'var(--ds-hover)', color: 'var(--ds-ink)' },
  }),
  ...(tone === 'inverse' && {
    color: 'var(--ds-inverse-ink)',
    backgroundColor: 'var(--ds-inverse)',
    '&:hover': { backgroundColor: 'var(--ds-inverse)', opacity: 0.9 },
  }),
  ...(tone === 'default' && {
    color: 'var(--ds-ink)',
    '&:hover': { backgroundColor: 'var(--ds-hover)' },
  }),
  ...(tone === 'night' && {
    color: 'var(--ds-night-ink-muted, rgba(244,243,246,0.6))',
    '&:hover': {
      backgroundColor: 'rgba(244,243,246,0.12)',
      color: 'var(--ds-night-ink, #f4f3f6)',
    },
  }),
}))

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { tone = 'default', ...rest },
  ref,
) {
  return <Root ref={ref} tone={tone} {...rest} />
})
